export class HttpConstants {
    static HEADER_CONTENT = 'Content-Type';
    static AUTHORIZATION = 'Authorization';
    static TYPE_JSON = 'application/json';
}